import { ExpressCheckoutButtonsController } from './ExpressCheckoutButtonsController';
export const createExpressCheckoutButtonsController = controllerParams => {
  return new ExpressCheckoutButtonsController(controllerParams);
};
//# sourceMappingURL=createExpressCheckoutButtonsController.js.map